import { render, staticRenderFns } from "./Ingresos.vue?vue&type=template&id=73b8b72a&scoped=true&lang=html&"
import script from "./Ingresos.vue?vue&type=script&lang=js&"
export * from "./Ingresos.vue?vue&type=script&lang=js&"
import style0 from "./Ingresos.vue?vue&type=style&index=0&id=73b8b72a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b8b72a",
  null
  
)

export default component.exports